class CustomerQuotation {
  constructor(id, opportunityId, products) {
    this._id = id;
    this._opportunityId = opportunityId;
    this._products = products || [];
  }

  getId() {
    return this._id;
  }

  getOpportunityId() {
    return this._opportunityId;
  }

  getProducts() {
    return this._products;
  }

  setId(newId) {
    this._id = newId;
    return this;
  }

  setOpportunityId(newOpportunityId) {
    this._opportunityId = newOpportunityId;
    return this;
  }

  setProducts(newProducts) {
    this._products = newProducts;
    return this;
  }

  serialize() {
    return { ...this, '@type': 'CustomerQuotation' };
  }

  clone() {
    return new CustomerQuotation(this._id, this._opportunityId, this._products);
  }

  static deserialize(raw) {
    return new CustomerQuotation(raw._id, raw._opportunityId, raw._products);
  }
}

export default CustomerQuotation;



// WEBPACK FOOTER //
// ./src/models/CustomerQuotation.js